export default function ProgressDots({ current, total = 4 }) {
  return (
    <div className="flex items-center justify-center gap-2 mb-8">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={`rounded-full transition-all duration-300 ${
            i + 1 === current
              ? 'w-5 h-2 bg-[var(--story-primary)]'
              : i + 1 < current
              ? 'w-2 h-2 bg-[var(--story-primary)]/40'
              : 'w-2 h-2 bg-[var(--story-line-strong)]'
          }`}
        />
      ))}
    </div>
  );
}
